import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

const Admin = () => {
    const [words, setWords] = useState([]);
    const [file, setFile] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    // Form states for single add
    const [newWord, setNewWord] = useState({
        word: '', meaning: '', level: 'Basic', chapter: 1, example_en: '', example_kr: ''
    });

    const fetchWords = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/admin/words?page=${page}`);
            setWords(res.data.words);
            setTotal(res.data.total);
        } catch (err) {
            alert('데이터를 불러오는데 실패했습니다.');
        }
        setLoading(false);
    }, [page]);

    useEffect(() => {
        fetchWords();
    }, [fetchWords]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return alert('파일을 선택해주세요.');
        const formData = new FormData();
        formData.append('file', file);

        setLoading(true);
        try {
            await axios.post('/api/admin/words/upload', formData);
            alert('업로드가 완료되었습니다.');
            setFile(null);
            setPage(1);
            fetchWords();
        } catch (err) {
            alert('업로드 실패');
        }
        setLoading(false);
    };

    const handleAddWord = async (e) => {
        e.preventDefault();
        try {
            await axios.post('/api/admin/words', newWord);
            alert('단어가 추가되었습니다.');
            setNewWord({ word: '', meaning: '', level: 'Basic', chapter: 1, example_en: '', example_kr: '' });
            fetchWords();
        } catch (err) {
            alert('추가 실패');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('정말 삭제하시겠습니까?')) return;
        try {
            await axios.delete(`/api/admin/words/${id}`);
            fetchWords();
        } catch (err) {
            alert('삭제 실패');
        }
    };

    return (
        <Layout header={{ title: '관리자 페이지', Backbtn: true, link: '/Main' }}>
            <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>

                {/* Bulk Upload Section */}
                <section style={{ backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '10px', marginBottom: '30px' }}>
                    <h3 style={{ marginBottom: '15px', fontWeight: 'bold' }}>CSV 일괄 업로드</h3>
                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                        * CSV 형식: word, meaning, level, example_en, example_kr, chapter
                    </p>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <input type="file" onChange={handleFileChange} accept=".csv" style={{ flex: 1 }} />
                        <button onClick={handleUpload} disabled={loading} style={{
                            padding: '8px 20px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '5px'
                        }}>
                            {loading ? '업로드 중...' : '업로드'}
                        </button>
                    </div>
                </section>

                {/* Add Single Word Section */}
                <section style={{ backgroundColor: '#fff', padding: '20px', border: '1px solid #eee', borderRadius: '10px', marginBottom: '30px' }}>
                    <h3 style={{ marginBottom: '15px', fontWeight: 'bold' }}>단어 개별 추가</h3>
                    <form onSubmit={handleAddWord} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        <input type="text" placeholder="단어" value={newWord.word} onChange={e => setNewWord({ ...newWord, word: e.target.value })} required />
                        <input type="text" placeholder="의미" value={newWord.meaning} onChange={e => setNewWord({ ...newWord, meaning: e.target.value })} required />
                        <select value={newWord.level} onChange={e => setNewWord({ ...newWord, level: e.target.value })}>
                            <option value="Basic">Basic</option>
                            <option value="Intermediate">Intermediate</option>
                            <option value="Advanced">Advanced</option>
                        </select>
                        <input type="number" placeholder="학습 일차 (Day)" value={newWord.chapter} onChange={e => setNewWord({ ...newWord, chapter: parseInt(e.target.value) })} />
                        <input type="text" placeholder="예문 (영어)" value={newWord.example_en} onChange={e => setNewWord({ ...newWord, example_en: e.target.value })} />
                        <input type="text" placeholder="예문 (한글)" value={newWord.example_kr} onChange={e => setNewWord({ ...newWord, example_kr: e.target.value })} />
                        <button type="submit" style={{ gridColumn: 'span 2', padding: '10px', backgroundColor: '#4ECB71', color: '#fff', border: 'none', borderRadius: '5px' }}>
                            추가하기
                        </button>
                    </form>
                </section>

                {/* Word List Table */}
                <section>
                    <h3 style={{ marginBottom: '15px', fontWeight: 'bold' }}>단어 목록 ({total})</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f4f4f4' }}>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>ID</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Day</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>단어</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>의미</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>관리</th>
                            </tr>
                        </thead>
                        <tbody>
                            {words.map(w => (
                                <tr key={w.id}>
                                    <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{w.id}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{w.chapter}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{w.word}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{w.meaning}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        <button onClick={() => handleDelete(w.id)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>삭제</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        <button disabled={page === 1} onClick={() => setPage(page - 1)}>이전</button>
                        <span>{page} / {Math.ceil(total / 50) || 1}</span>
                        <button disabled={page * 50 >= total} onClick={() => setPage(page + 1)}>다음</button>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default Admin;
